import React from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import {
  REPAIR_ADDON_MAX_QUANTITY,
  REPAIR_ADDON_MIN_QUANTITY,
  normalizeRepairAddonQuantity,
} from '@/core/expenses/estimatedRepairAddons'

interface RepairAddonQuantityStepperProps {
  value: number | undefined
  onChange: (quantity: number) => void
  disabled?: boolean
}

export const RepairAddonQuantityStepper: React.FC<RepairAddonQuantityStepperProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const quantity = normalizeRepairAddonQuantity(value)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
      <IconButton
        size="small"
        aria-label="Decrease quantity"
        disabled={disabled || quantity <= REPAIR_ADDON_MIN_QUANTITY}
        onClick={() => onChange(quantity - 1)}
      >
        <RemoveIcon fontSize="small" />
      </IconButton>
      <Typography variant="body2" fontWeight={600} sx={{ minWidth: 20, textAlign: 'center' }}>
        {quantity}
      </Typography>
      <IconButton
        size="small"
        aria-label="Increase quantity"
        disabled={disabled || quantity >= REPAIR_ADDON_MAX_QUANTITY}
        onClick={() => onChange(quantity + 1)}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}
